import { Location, locationName } from '@cobliteam/common-types';

import { lazy } from '@cobliteam/lazy-with-retries';

const TrackingPage = lazy(() => import('@cobliteam/tracking/src/pages/TrackingPage'));
const TrackingHistoryPage = lazy(() => import('@cobliteam/tracking/src/pages/TrackingHistoryPage'));

const routes = [
  {
    title: locationName[Location.TRACKING],
    path: Location.TRACKING,
    component: TrackingPage,
  },
  {
    title: locationName[Location.TRACKING_HISTORY],
    path: Location.TRACKING_HISTORY,
    component: TrackingHistoryPage,
  },
];

export default routes;
